import "./settingsOptionsList.scss";

import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { findDOMNode } from "react-dom";

import { SETTINGS_OPTION_LIST_VIEW } from "../../constants/identifiers";
import Dimensions from "../../constants/styles/dimensions";
import { PropTypeShapes } from "../../types";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";
import preprocessorQuery from "../../utils/preprocessorQuery";
import userInputValidators from "../../utils/userInputValidators";
import { withContainerContext } from "../container/ContainerContext";
import { asDragSource } from "../dragAndDrop/DraggableComponent";
import FormTextField from "../form/FormTextField";
import Icon from "../interface/Icon";
import ModalField from "../modal/ModalField";
import ModalRow from "../modal/ModalRow";

const SETTINGS_OPTION_LIST_ITEM_ID = "SETTINGS_OPTION_LIST_ITEM_ID";

const clickWasDragHandle = e => hasAncestorOfClass(e.target, "dragHandle");

const dragCallbacks = {
  beginDrag: _props => {
    // TODO: Do we want to set isDragging or similar...?
  },

  canDrag: (props, _dragSource, e) => {
    return clickWasDragHandle(e) && props.canDrag;
  },

  getDragSourceParams: props => {
    const result = {
      itemId: `${props.viewId}-${props.index}`,
      index: props.index,
      itemType: SETTINGS_OPTION_LIST_ITEM_ID,
      sourceView: props.viewId,
      sourceViewType: SETTINGS_OPTION_LIST_VIEW
    };
    return result;
  },

  getPreviewElement: (props, dragSource) => {
    const sourceRect = dragSource && dragSource.node ? dragSource.node.getBoundingClientRect() : null;
    return renderItemPreview(props, sourceRect.width);
  }
};

const renderItemPreview = (props, fixedWidth) => {
  const cloneProps = _.clone(props);
  cloneProps.isSelected = false;
  cloneProps.slideUp = false;
  cloneProps.slideDown = false;
  cloneProps.onClick = null;
  cloneProps.onSuperClick = null;
  return renderItem(cloneProps, fixedWidth);
};

const renderItem = (props, fixedWidth) => {
  const isIos = preprocessorQuery.isIos();

  let width = Dimensions.MODAL_SETTINGS_LIST_OPTIONS_WIDTH;

  if (isIos || props.useContainerWidth) {
    if (fixedWidth) {
      width = fixedWidth;
    } else {
      width = null;
    }
  }

  const style = {
    opacity: props.isDragging ? 0 : 1,
    transform: props.slideUp ? `translateY(-40px)` : props.slideDown ? `translateY(40px)` : `translateY(0px)`,
    width: !_.isNil(width) ? `${width}px` : null
  };

  return (
    <div className={`settingsOptionRow`} style={style}>
      <ModalRow>
        <ModalField flex={1}>
          <Icon className="dragHandle" icon={props.canDrag ? "moveRow" : "blank"} color="iconMono" />
        </ModalField>
        <ModalField flex={15}>
          <FormTextField
            value={props.label}
            placeholder={props.placeholder}
            onChange={props.onChange}
            validator={userInputValidators.noEmpty}
            autoFocusOnEmpty={props.autoFocusOnEmpty}
          />
        </ModalField>
        <ModalField flex={1}>
          <Icon
            icon={props.canDelete ? "listDelete" : "blank"}
            color="iconMono"
            onClick={props.canDelete ? props.onDelete : null}
          />
        </ModalField>
      </ModalRow>
    </div>
  );
};

class SettingsDraggableOptionRow extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      disableDrag: false
    };
  }

  componentDidMount() {
    this._domNode = findDOMNode(this);
  }

  render() {
    return renderItem(this.props);
  }
}

SettingsDraggableOptionRow.propTypes = {
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocusOnEmpty: PropTypes.bool,
  id: PropTypes.string,
  index: PropTypes.number,
  viewId: PropTypes.string.isRequired,
  useContainerWidth: PropTypes.bool,

  canDrag: PropTypes.bool,
  canDelete: PropTypes.bool,

  // Sliding out of way
  slideUp: PropTypes.bool,
  slideDown: PropTypes.bool,

  // From asDragSource
  isDragging: PropTypes.bool,
  dragIsFromSameSource: PropTypes.bool,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired,
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number
};

renderItem.propTypes = SettingsDraggableOptionRow.propTypes;

export default withContainerContext(asDragSource(SettingsDraggableOptionRow, SETTINGS_OPTION_LIST_VIEW, dragCallbacks));
